const campos = {
  'transportadorProprietarioVeiculo.cnhNumero': 'Veículo - CNH - Número',
  'transportadorProprietarioCarreta.anttNumero': 'Carreta - ANTT - Número',
  'transportadorProprietarioCarreta.cnhNumero': 'Carreta - CNH - Número',
  'veiculoProprietarioAnttNumero': 'Veículo - ANTT - Número',
  'carretaProprietarioAnttNumero': 'Carreta - ANTT - Número',
  'motoristaAnttNumero': 'Motorista - ANTT - Número',
  'veiculoRenavan': 'Veículo - Renavam',
  'carretaRenavan': 'Carreta - Renavam',
  'motoristaCnhNumero': 'Motorista - CNH - Número',
  'observacao': 'Observação',
  'rg.nomeMae': 'RG - Nome da Mãe',
  'nome': 'Nome',
  'cnh.numero': 'CNH - NÚmero',
  'proprietario.cnhNumero': 'Proprietário - CNH - NÚmero',
  'proprietario.nome': 'Proprietário - Nome',
  'endereco.numero': 'Endereço - Número',
  'crlvFotoId': 'CRLV - Foto',
  'proprietario.anttFotoId': 'Proprietário - ANTT - Foto',
  'proprietario.habilitacaoFotoId': 'Proprietário - Habilitação - Foto',
  'proprietario.enderecoFotoId': 'Proprietário - Comprovante Residência - Foto',
  'motoristaHabilitacaoFotoId': 'Habilitação - Foto',
  'motoristaEnderecoFotoId': 'Comprovante de Endereço - Foto',
  'motoristaSelfieFotoId': 'Selfie - Foto',
  'veiculoPlaca': 'Placa Veículo',
  'carretaPlaca': 'Placa Carreta',
  'carretaAdicionalPlaca': 'Placa Carreta Adicional',
}

export default campos



// WEBPACK FOOTER //
// ./src/services/campos.js